function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { VideoStartupStates } from './video-startup.enums';
export { VideoStartupStates } from './video-startup.enums';
export var VideoStartupState = /*#__PURE__*/ function() {
    "use strict";
    function VideoStartupState(name) {
        var _this = this;
        _class_call_check(this, VideoStartupState);
        _define_property(this, "_name", void 0);
        _define_property(this, "initialise", function() {
            var actionName = 'Initialise';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "callVideoProvider", function() {
            var actionName = 'Call Video Provider';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "initialiseAdverts", function() {
            var actionName = 'Initialise Adverts Manager';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "callVam", function() {
            var actionName = 'Call Vam';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "bootstrapAds", function() {
            var actionName = 'Bootstrap Ads';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "callAdsData", function() {
            var actionName = 'Call Advertisement';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "startEngine", function() {
            var actionName = 'Start Engine';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "skipAdvertisement", function() {
            var actionName = 'Skip Advertisement';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "destroy", function() {
            var actionName = 'Destroy';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "discard", function() {
            var actionName = 'Discard';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "retry", function() {
            var actionName = 'Retry';
            throw new Error(_this.buildInvalidOperation(actionName));
        });
        _define_property(this, "toString", function() {
            return _this.getName();
        });
        _define_property(this, "type", function() {
            var state = _this.getName();
            return VideoStartupStates[state];
        });
        this._name = name;
    }
    _create_class(VideoStartupState, [
        {
            key: "getName",
            value: function getName() {
                return this._name;
            }
        },
        {
            key: "buildInvalidOperation",
            value: function buildInvalidOperation(actionName) {
                var state = this.getName();
                return "Invalid operation: can't ".concat(actionName, " while in ").concat(state, " State");
            }
        }
    ]);
    return VideoStartupState;
}();
var DestroyableVideoStartupState = /*#__PURE__*/ function(VideoStartupState) {
    "use strict";
    _inherits(DestroyableVideoStartupState, VideoStartupState);
    function DestroyableVideoStartupState() {
        _class_call_check(this, DestroyableVideoStartupState);
        var _this;
        _this = _call_super(this, DestroyableVideoStartupState, arguments), _define_property(_this, "destroy", function() {
            return new DestroyedState(VideoStartupStates.Destroyed);
        });
        return _this;
    }
    return DestroyableVideoStartupState;
}(VideoStartupState);
export var UninitialisedState = /*#__PURE__*/ function(DestroyableVideoStartupState) {
    "use strict";
    _inherits(UninitialisedState, DestroyableVideoStartupState);
    function UninitialisedState() {
        _class_call_check(this, UninitialisedState);
        var _this;
        _this = _call_super(this, UninitialisedState, arguments), _define_property(_this, "initialise", function() {
            return new InitialisedState(VideoStartupStates.Initialised);
        });
        return _this;
    }
    return UninitialisedState;
}(DestroyableVideoStartupState);
export var InitialisedState = /*#__PURE__*/ function(DestroyableVideoStartupState) {
    "use strict";
    _inherits(InitialisedState, DestroyableVideoStartupState);
    function InitialisedState() {
        _class_call_check(this, InitialisedState);
        var _this;
        _this = _call_super(this, InitialisedState, arguments), _define_property(_this, "callVideoProvider", function() {
            return new VideoProviderCalledState(VideoStartupStates.VideoProviderCalled);
        }), _define_property(_this, "discard", function() {
            return new DiscardedState(VideoStartupStates.Discarded);
        });
        return _this;
    }
    return InitialisedState;
}(DestroyableVideoStartupState);
export var VideoProviderCalledState = /*#__PURE__*/ function(DestroyableVideoStartupState) {
    "use strict";
    _inherits(VideoProviderCalledState, DestroyableVideoStartupState);
    function VideoProviderCalledState() {
        _class_call_check(this, VideoProviderCalledState);
        var _this;
        _this = _call_super(this, VideoProviderCalledState, arguments), _define_property(_this, "initialiseAdverts", function() {
            return new AdvertsInitialisedState(VideoStartupStates.AdvertsInitialised);
        }), _define_property(_this, "discard", function() {
            return new DiscardedState(VideoStartupStates.Discarded);
        }), // If there's no advertisement at all
        _define_property(_this, "startEngine", function() {
            return new EngineStartedState(VideoStartupStates.EngineStarted);
        });
        return _this;
    }
    return VideoProviderCalledState;
}(DestroyableVideoStartupState);
export var AdvertsInitialisedState = /*#__PURE__*/ function(DestroyableVideoStartupState) {
    "use strict";
    _inherits(AdvertsInitialisedState, DestroyableVideoStartupState);
    function AdvertsInitialisedState() {
        _class_call_check(this, AdvertsInitialisedState);
        var _this;
        _this = _call_super(this, AdvertsInitialisedState, arguments), _define_property(_this, "callVam", function() {
            return new VamCalledState(VideoStartupStates.VamCalled);
        }), // Now TV does not call VAM so it can call Advertisement
        // after calling VPI/OVP
        _define_property(_this, "bootstrapAds", function() {
            return new BootstrapAdsState(VideoStartupStates.AdsBootstrapped);
        }), // Semantically different from the previous one
        // even if we go to the same state
        _define_property(_this, "skipAdvertisement", function() {
            return new AdInsertionCalledState(VideoStartupStates.AdsInsertionCalled);
        });
        return _this;
    }
    return AdvertsInitialisedState;
}(DestroyableVideoStartupState);
export var VamCalledState = /*#__PURE__*/ function(DestroyableVideoStartupState) {
    "use strict";
    _inherits(VamCalledState, DestroyableVideoStartupState);
    function VamCalledState() {
        _class_call_check(this, VamCalledState);
        var _this;
        _this = _call_super(this, VamCalledState, arguments), _define_property(_this, "bootstrapAds", function() {
            return new BootstrapAdsState(VideoStartupStates.AdsBootstrapped);
        }), _define_property(_this, "callAdsData", function() {
            return new AdInsertionCalledState(VideoStartupStates.AdsInsertionCalled);
        }), _define_property(_this, "skipAdvertisement", function() {
            return new AdInsertionCalledState(VideoStartupStates.AdsInsertionCalled);
        }), _define_property(_this, "discard", function() {
            return new DiscardedState(VideoStartupStates.Discarded);
        });
        return _this;
    }
    return VamCalledState;
}(DestroyableVideoStartupState);
export var BootstrapAdsState = /*#__PURE__*/ function(DestroyableVideoStartupState) {
    "use strict";
    _inherits(BootstrapAdsState, DestroyableVideoStartupState);
    function BootstrapAdsState() {
        _class_call_check(this, BootstrapAdsState);
        var _this;
        _this = _call_super(this, BootstrapAdsState, arguments), _define_property(_this, "callAdsData", function() {
            return new AdInsertionCalledState(VideoStartupStates.AdsInsertionCalled);
        }), // Semantically different from the previous one
        // even if we go to the same state
        _define_property(_this, "skipAdvertisement", function() {
            return new AdInsertionCalledState(VideoStartupStates.AdsInsertionCalled);
        }), _define_property(_this, "discard", function() {
            return new DiscardedState(VideoStartupStates.Discarded);
        });
        return _this;
    }
    return BootstrapAdsState;
}(DestroyableVideoStartupState);
export var AdInsertionCalledState = /*#__PURE__*/ function(DestroyableVideoStartupState) {
    "use strict";
    _inherits(AdInsertionCalledState, DestroyableVideoStartupState);
    function AdInsertionCalledState() {
        _class_call_check(this, AdInsertionCalledState);
        var _this;
        _this = _call_super(this, AdInsertionCalledState, arguments), _define_property(_this, "startEngine", function() {
            return new EngineStartedState(VideoStartupStates.EngineStarted);
        }), _define_property(_this, "discard", function() {
            return new DiscardedState(VideoStartupStates.Discarded);
        });
        return _this;
    }
    return AdInsertionCalledState;
}(DestroyableVideoStartupState);
export var EngineStartedState = /*#__PURE__*/ function(DestroyableVideoStartupState) {
    "use strict";
    _inherits(EngineStartedState, DestroyableVideoStartupState);
    function EngineStartedState() {
        _class_call_check(this, EngineStartedState);
        var _this;
        _this = _call_super(this, EngineStartedState, arguments), _define_property(_this, "discard", function() {
            return new DiscardedState(VideoStartupStates.Discarded);
        }), _define_property(_this, "destroy", function() {
            return new DestroyedState(VideoStartupStates.Destroyed);
        }), _define_property(_this, "retry", function() {
            return new RetriedState(VideoStartupStates.Retried);
        });
        return _this;
    }
    return EngineStartedState;
}(DestroyableVideoStartupState);
export var DiscardedState = /*#__PURE__*/ function(DestroyableVideoStartupState) {
    "use strict";
    _inherits(DiscardedState, DestroyableVideoStartupState);
    function DiscardedState() {
        _class_call_check(this, DiscardedState);
        var _this;
        _this = _call_super(this, DiscardedState, arguments), // We might want to initialise if a prefetch
        // scenario failed or even if an "initialised"
        // scenario (non-prefetch) failed and we want to
        // retry the start of the session
        _define_property(_this, "initialise", function() {
            return new InitialisedState(VideoStartupStates.Initialised);
        });
        return _this;
    }
    return DiscardedState;
}(DestroyableVideoStartupState);
export var DestroyedState = /*#__PURE__*/ function(VideoStartupState) {
    "use strict";
    _inherits(DestroyedState, VideoStartupState);
    function DestroyedState() {
        _class_call_check(this, DestroyedState);
        var _this;
        _this = _call_super(this, DestroyedState, arguments), // We may enter a destroyed state if the prefetch is canceled by client,
        // Or when a cache expires
        _define_property(_this, "initialise", function() {
            return new InitialisedState(VideoStartupStates.Initialised);
        }), _define_property(_this, "retry", function() {
            return new RetriedState(VideoStartupStates.Retried);
        });
        return _this;
    }
    return DestroyedState;
}(VideoStartupState);
export var RetriedState = /*#__PURE__*/ function(VideoStartupState) {
    "use strict";
    _inherits(RetriedState, VideoStartupState);
    function RetriedState() {
        _class_call_check(this, RetriedState);
        var _this;
        _this = _call_super(this, RetriedState, arguments), _define_property(_this, "initialise", function() {
            return new InitialisedState(VideoStartupStates.Initialised);
        }), _define_property(_this, "destroy", function() {
            return new DestroyedState(VideoStartupStates.Destroyed);
        });
        return _this;
    }
    return RetriedState;
}(VideoStartupState);

//# sourceMappingURL=video-startup-states.js.map